export default "__VITE_ASSET__a22eca9a__"